import * as React from "react";
import { BrowserRouter } from "react-router-dom";
import Nav from "./components/Nav";
import Home from "./pages/Home";
import "../src/index.css";
function App() {
  return (
    <BrowserRouter>
      <Home />
      {/* <Nav /> */}
    </BrowserRouter>
  );
}

export default App;
